import React from 'react';
import MessageMenu from './MessageMenu';

const MessagesPage = () => {
    return (
        <div className="mobile-messages-page h-[86vh] rounded-2xl border border-purple-200 bg-white dark:bg-zinc-900">
            <MessageMenu
                pageMode
                isOpen
                onClose={() => {}}
                isSidebarOpen={false}
            />
        </div>
    );
};

export default MessagesPage;